import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../lib/auth";
import { SignatureBg } from "../components/SignatureBg";

export default function LoginPage() {
  const { login, user } = useUser();
  const loc = useLocation() as any;
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (user) {
    nav("/dashboard", { replace: true });
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      await login(email, password);
      nav(loc.state?.from || "/dashboard", { replace: true });
    } catch (e: any) {
      setError(e?.message || "Invalid login");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-split">
      {/* Left: branded emerald visual panel — per the Alief brand kit's
          split-screen login direction. Her fleur-de-lis brand mark sits above
          the wordmark. Hidden on small screens so the form stays the priority. */}
      <aside className="login-visual has-signature-bg" aria-hidden="true">
        <SignatureBg variant="mark" />
        <div className="login-visual-inner">
          <img className="login-visual-logo" src="/brand-mark.png" alt="" />
          <div className="login-visual-wordmark">Alief Dispute Hub</div>
          <p className="login-visual-endorse">Powered by Alief Financial</p>
          <p className="login-visual-tag">Analyze Smarter. Dispute Better. Powered by AI.</p>
          <ul className="login-visual-points">
            <li>AI-assisted credit-report analysis</li>
            <li>Guided, compliant dispute letters</li>
            <li>Client pipeline &amp; a branded client portal</li>
          </ul>
        </div>
      </aside>
      {/* Right: clean white/cream authentication panel. */}
      <div className="login-formside">
      <div className="login-card">
        <div className="brand-lockup login-brand">
          <div className="brand-mark">
            <img src="/brand-mark.png" alt="Alief Dispute Hub" />
          </div>
          <div>
            <strong className="brand-wordmark">Alief Dispute Hub</strong>
            <span>Analyze Smarter. Dispute Better. Powered by AI.</span>
          </div>
        </div>
        <h1 id="login-heading">Staff sign-in</h1>
        <form onSubmit={submit} className="stacked-form" aria-labelledby="login-heading">
          <label className="form-field">
            <span>Email</span>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="form-field">
            <span>Password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {error && <p className="error-text" role="alert">{error}</p>}
          <button className="primary-button wide-button" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <button type="button" className="link-button" style={{ marginTop: 4 }} onClick={() => nav("/forgot-password")}>
            Forgot your password?
          </button>
        </form>
      </div>
      </div>
    </div>
  );
}
